import {Component, OnInit, Input, AfterContentChecked, ChangeDetectorRef, forwardRef, OnChanges, SimpleChanges} from '@angular/core';
import { FormBuilder, FormArray, FormGroup, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, NG_VALIDATORS } from '@angular/forms';
import { AbwDatasourceColumn, TYPE_DEFAULT_VALUE, Model_WorkflowComponent, FONCTION_WORKFLOW_COMPONENT_OPTIONS, Model_VariableEnvironnement, EXPRESSION_FIELD_SCOPE } from 'src/app/app.models';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'abw-datasource-filters-columns',
    templateUrl: './datasource-filters-columns.component.html',
    styleUrls: ['./datasource-filters-columns.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatasourceFiltersColumnsComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DatasourceFiltersColumnsComponent),
            multi: true
        }
    ],
})
export class DatasourceFiltersColumnsComponent implements OnInit, AfterContentChecked, ControlValueAccessor {
    @Input() datasourceColumns: AbwDatasourceColumn[] = [];
    @Input() workflowComponents: Model_WorkflowComponent[] = [];
    @Input() gridComponents?: Model_WorkflowComponent[];
    @Input() variables: Model_VariableEnvironnement[] = [];
    @Input() value: any;
    displayedColumns = ['DATASOURCE_COLUMN', 'TYPE_DEFAULT_VALUE', 'TYPE_OPERANDE', 'DEFAULT_VALUE', 'ACTIONS'];
    dataSource = new MatTableDataSource<FormGroup>();
    form = this._formBuilder.group({
        formArray: this._formBuilder.array([])
    });
    TYPE_DEFAULT_VALUE = TYPE_DEFAULT_VALUE;
    FONCTION_WORKFLOW_COMPONENT_OPTIONS = FONCTION_WORKFLOW_COMPONENT_OPTIONS;
    @Input() operators: { VALUE: any, DISPLAY: string, standalone?: boolean }[] = []

    constructor(
        private _formBuilder: FormBuilder,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngAfterContentChecked() {
        this._cdf.detectChanges();
    }

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: {DATASOURCE_COLUMN: string, DEFAULT_VALUE: number, TYPE_DEFAULT_VALUE: any, TYPE_OPERANDE: any }[]) {
        if (!!value) {
            const rows = value.map(row => this._formBuilder.group({
                DATASOURCE_COLUMN: [row.DATASOURCE_COLUMN],
                TYPE_DEFAULT_VALUE: [row.TYPE_DEFAULT_VALUE],
                TYPE_OPERANDE: [row.TYPE_OPERANDE],
                DEFAULT_VALUE: [row.DEFAULT_VALUE]
            }));
            this.value = rows; 
            this.dataSource.data = rows;
        }
    }
    validate(control: any): { [key: string]: any } | null {
        const isValid = (this.dataSource.data as FormGroup[]).map(f => f.valid).reduce((current, next) => current && next, true);
        return !isValid ? { required: true } : null;
    }

	onValueChanged() {
        const rows = this.dataSource.data;
        this.value = rows.map(formGroup => formGroup.value);
	  	this.propagateChange(this.value);
        this._cdf.detectChanges();
	}

    addRow() {
        const rows = this.dataSource.data;
        const rowFormGroup = this._formBuilder.group({
            DATASOURCE_COLUMN: [this.datasourceColumns.length > 0 ? this.datasourceColumns[0].name : null, Validators.required],
            TYPE_DEFAULT_VALUE: [TYPE_DEFAULT_VALUE.CONSTANT, Validators.required],
            TYPE_OPERANDE: [this.operators.length > 0 ? this.operators[0].VALUE : null, Validators.required],
            DEFAULT_VALUE: [null, Validators.required]
        });
        rows.push(rowFormGroup);
        this.dataSource.data = rows;
        this.onValueChanged();
    }

    removeRow(index: number) {
        const rows = this.dataSource.data;
        rows.splice(index, 1);
        this.dataSource.data = rows;
        this.onValueChanged();
    }

    isStandaloneOperator(row: FormGroup) {
        const operator = this.operators.find(o => o.VALUE == row.controls.TYPE_OPERANDE.value);
        if (!operator) { return false; }
        return operator.standalone === true;
    }
}